import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card } from "../ui/card";
import { Label } from "../ui/label";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { Users, ListFilter } from "lucide-react";
import { PartnerSendPicker } from "./PartnerSendPicker";

const OPTS = [
  ["all", "Tutti i partner", "Il servizio viene inviato a tutti i partner attivi.", Users],
  ["lista", "Lista di partner", "Scegli una o più liste salvate oppure singoli partner.", ListFilter],
];

// Scelta destinatari in creazione (nascosta in modifica e in assegnazione diretta).
export const SendModeCard = ({ sendMode, setSendMode, partners, selectedIds, setSelectedIds, selectedListIds, setSelectedListIds, testPrefix = "send" }) => {
  const [lists, setLists] = useState([]);
  useEffect(() => { api.get("/partner-lists").then(({ data }) => setLists(data)).catch(() => {}); }, []);
  return (
    <Card className="p-6 border-slate-200 mb-5" data-testid={`${testPrefix}-mode-card`}>
      <Label className="nx-label mb-3 block">Destinatari dell'invio</Label>
      <RadioGroup value={sendMode} onValueChange={setSendMode} className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {OPTS.map(([value, title, desc, Icon]) => (
          <label key={value} htmlFor={`${testPrefix}-${value}`} className={`flex items-start gap-3 rounded-lg border p-4 cursor-pointer transition-colors ${sendMode === value ? "border-primary bg-primary/5" : "border-slate-200"}`}>
            <RadioGroupItem value={value} id={`${testPrefix}-${value}`} data-testid={`${testPrefix}-mode-${value}`} className="mt-0.5" />
            <div>
              <div className="flex items-center gap-1.5 font-semibold text-sm text-slate-800"><Icon className="h-4 w-4 text-primary" /> {title}</div>
              <p className="text-xs text-slate-500 mt-1">{desc}</p>
            </div>
          </label>
        ))}
      </RadioGroup>
      {sendMode === "lista" && (
        <div className="mt-4">
          <PartnerSendPicker partners={partners.filter((p) => p.active !== false)} lists={lists} selectedIds={selectedIds} setSelectedIds={setSelectedIds}
            selectedListIds={selectedListIds} setSelectedListIds={setSelectedListIds} testPrefix={testPrefix} />
        </div>
      )}
    </Card>
  );
};
